'use strict';
const checkoutConstants = require('../checkoutConstants');
const SFCC_ADYEN_PAYMENT_NAME = (checkoutConstants.PAYMENT_METHODS && checkoutConstants.PAYMENT_METHODS.ADYEN_COMPONENT) || '';

/**
 * set the credit card field as required or not
 * @param {boolen} value to set the required
 */
function updateCreditCardFieldsAsRequired(value) {
    $('#cardNumber').prop('required', value).parent().toggleClass('required', value);
    $('#securityCode').prop('required', value).parent().toggleClass('required', value);
    $('#expirationMonth').prop('required', value).parent().toggleClass('required', value);
    $('#expirationYear').prop('required', value).parent().toggleClass('required', value);
    $('#holderName').prop('required', value).parent().toggleClass('required', value);
}

/**
 * Updates product line item price
 * @param {dw.catalog.Product[]} basketItems Line items in the current basket
 */
function updateProductSummary(basketItems) {
    basketItems.forEach(function (item) {
        $(`.product-line-item[data-product-line-item='${item.UUID}'] .product-line-item__qty-price`)
            .find('.price')
            .remove()
            .end()
            .append(item.priceItem.renderedPrice);
    });
}

module.exports = {
    updateGiftCardlist: (data) => {
        var $giftCardContainer = $('.js-gift-card-list');

        if (data && data.paymentInstrumentsDetails && data.paymentInstrumentsDetails.giftCardDetails) {
            var giftCardDetails = data.paymentInstrumentsDetails.giftCardDetails;

            // Hide all Gift card related stuffs
            $giftCardContainer.hide().empty();

            if (giftCardDetails.appliedGiftCards.giftCards &&
                giftCardDetails.appliedGiftCards.giftCards.length > 0) {
                var giftCards = giftCardDetails.appliedGiftCards.giftCards;

                for (var index = 0; index < giftCards.length; index++) {
                    var card = giftCards[index];
                    var $tpl = $('#appliedGiftCardTpl')
                        .clone()
                        .removeClass('d-none')
                        .removeAttr('id');

                    $tpl.find('.btn-remove-gift-refund').data('uuid', card.piUUID);
                    $tpl.find('.js-gift-card-number').text(card.giftCardCode);
                    $tpl.find('.js-gift-card-amount').text(card.giftCardAmount);

                    $giftCardContainer.append($tpl);
                }

                $giftCardContainer.show();
            }

            $('body').trigger('checkout:toggleKlarnaPaymentOption');
        }
    },

    updatePaymentsection: (data) => {
        if (data && data.paymentInstrumentsDetails) {
            var paymentInstruments = data.paymentInstrumentsDetails;
            var notFullyCoveredByAny = data.paymentInstrumentsDetails.isNotFullyCoveredByAny;
            var $loyaltyRewardsContainer = $('body').find('.js-apply-loyalty-rewards');
            var isRewardsAnyIncrement = $loyaltyRewardsContainer.find('.rewards-balance-redemption-banner').length;

            if (notFullyCoveredByAny) {
                $('.gift-card-promo-entry-content').slideDown();
                $('.payment-section-heading').removeClass('d-none');

                var $billingPaymentOptionsBlock = $('.billing-payment-options-block');
                if ($billingPaymentOptionsBlock.is(':hidden')) {
                    $billingPaymentOptionsBlock.slide('show');
                }

                if (isRewardsAnyIncrement) {
                    $loyaltyRewardsContainer.slide(data.totals.subTotalAfterOrderDiscounts && data.totals.subTotalAfterOrderDiscounts.value ? 'show' : 'hide');
                } else if (data.loyaltyRewards && data.loyaltyRewards.loyaltyRewardDropDownOptions && data.loyaltyRewards.loyaltyRewardDropDownOptions.length) {
                    $loyaltyRewardsContainer.slide('show');
                }

                var checkedPaymentMethod = $('#paymentMethodsList').find('input[type=radio]:checked').val();
                if ($('#selectedPaymentOption').val() === 'GIFT_CERTIFICATE') {
                    var selectedPaymentOptionValue = checkedPaymentMethod === 'PayPal' || checkedPaymentMethod === 'PayByLink' ? checkedPaymentMethod : SFCC_ADYEN_PAYMENT_NAME;
                    $('#selectedPaymentOption').val(selectedPaymentOptionValue);
                }

                // "credit_card" is the common radio button component that holds the "scheme" and "storedCard" adyen components
                const isCcOrPbl = checkedPaymentMethod === 'credit_card' || checkedPaymentMethod === 'PayByLink';
                const isPayPalAuthorized = !!(checkedPaymentMethod === checkoutConstants.PAYMENT_METHODS.PAYPAL && $('#braintreePaypalNonce').val());

                updateCreditCardFieldsAsRequired(isCcOrPbl);

                $('.btn-checkout.submit-payment').toggleClass('d-none', !isCcOrPbl && !isPayPalAuthorized).toggleClass('d-block', isCcOrPbl || isPayPalAuthorized);
            } else {
                if (paymentInstruments.giftCardDetails && paymentInstruments.giftCardDetails.isFullyCovered) {
                    $('#selectedPaymentOption').val('GIFT_CERTIFICATE');
                }

                if (!(paymentInstruments.loyaltyRewardsDetails && paymentInstruments.loyaltyRewardsDetails.isLoyaltyRewardsApplied)) {
                    $loyaltyRewardsContainer.slide('hide');
                }

                $('.gift-card-promo-entry-content').slideUp();
                $('.billing-payment-options-block').slideUp();
                $('.payment-section-heading').addClass('d-none');

                updateCreditCardFieldsAsRequired(false);

                $('.btn-checkout.submit-payment').toggleClass('d-block', true).toggleClass('d-none', false);
                $('.checkout-accordion.review').toggleClass('d-none', false);
            }
        }
    },

    updateOrderSummary: (totals) => {
        var $summaryContainer = $('.order-total-summary, .order-totals-wrapper');

        let freeShippingText = (window.resources && window.resources.localizedFreeShippingText);
        var isAdjustedShippingCostFree = freeShippingText && totals.adjustedShippingTotalCost.toLowerCase() === freeShippingText.toLowerCase();

        // .js-subtotal-value is in cart order summary and under header, and in minicart
        // .sub-total is in checkout order summary
        $summaryContainer.find('.js-subtotal-value, .sub-total').text(totals.subTotal);

        // Order-level discount
        $summaryContainer.find('.order-discount').toggleClass('hide-order-discount', !totals.orderLevelDiscountTotal.value);
        $summaryContainer.find('.order-discount-total .value').text(`- ${totals.orderLevelDiscountTotal.formatted}`);

        // "You Save" discount details
        $('.total-discount').toggleClass('hide-order-discount', !(totals.discountTotal && totals.discountTotal.value));
        $('.total-discount-text').text((totals.discountTotal && totals.discountTotal.text) || '');

        if (totals.discounts) {
            const $discountDetailsContainer = $('#discountDetails');
            const discountDetailMarkup = (label, value) => `
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="label">${label}</div>
                    <div class="value">${value}</div>
                </div>
            `;

            $discountDetailsContainer.empty();
            totals.discounts.forEach((discount) => {
                if (discount.applied && discount.relationship) {
                    discount.relationship.forEach((discountRelationship) => {
                        $discountDetailsContainer.append(discountDetailMarkup(
                            discountRelationship.name || discountRelationship.promotionID,
                            discountRelationship.formattedPrice
                        ));
                    });
                } else if (!('applied' in discount)) {
                    $discountDetailsContainer.append(discountDetailMarkup(discount.lineItemText, discount.price));
                }
            });
        }

        if (totals.showLoyaltyTotal && totals.loyalty && totals.loyalty.value > 0) {
            $('.order-loyalty, .loyalty-discount').removeClass('d-none');
            $('.order-loyalty-total, .loyalty-discount-total').text('- ' + totals.loyalty.formatted);
        } else {
            $('.order-loyalty, .loyalty-discount').addClass('d-none');
        }

        $summaryContainer.find('.shipping-total-cost').text(isAdjustedShippingCostFree ? totals.adjustedShippingTotalCost : totals.totalShippingCost);
        $summaryContainer.find('.shipping-discount').toggleClass('d-none', (!totals.shippingLevelDiscountTotal.value || isAdjustedShippingCostFree));
        $summaryContainer.find('.shipping-discount-total').text(`- ${totals.shippingLevelDiscountTotal.formatted}`);
        $summaryContainer.find('.tax-total').text(totals.totalTax);
        $summaryContainer.find('.grand-total-sum').text(totals.grandTotal);
        $summaryContainer.find('.js-grand-total-sum').attr('data-klarna-total', totals.totalGrossPrice);

        if (totals.showGiftCardTotal) {
            $summaryContainer.find('.amount-gift-card').text(totals.giftCardTotal.formatted);
            $summaryContainer.find('.row-amount-gift-card').show();
            $summaryContainer.find('.grand-total-sum').text(totals.amountDue.formatted);
        } else {
            $summaryContainer.find('.amount-gift-card').text('');
            $summaryContainer.find('.row-amount-gift-card').hide();
        }

        // After GC/PromoCode applied or Removed update the PayPal config amount in data-braintree-config
        var $payPalButtonContainer = $('.js_braintree_paypal_billing_button');
        if ($payPalButtonContainer.length) {
            $('body').trigger('checkout:updateBrainTreeConfig');
        }

        // update Klarna Placements
        var klarnaPriceValue = totals.grandTotal.replace(/\D/g, ''); // $1,234.56 -> 123456 (Klarna wants micro amount)
        $('klarna-placement').attr('data-purchase-amount', klarnaPriceValue); // CAN NOT USE .data() HERE. Gotta update the attribute directly.
        if (window.Klarna && window.Klarna.OnsiteMessaging) {
            window.Klarna.OnsiteMessaging.refresh();
        }
    },

    updateCreditCardFields: (value) => {
        updateCreditCardFieldsAsRequired(value);
    },
    updateProductSummary: updateProductSummary
};
